import React, { useEffect, useState, useCallback } from "react";
import API from "../Services/Employee";

const Employee = ({ selectedEmployee, setSelectedEmployee, employee }) => {
    const [employeeList, setEmployeeList] = useState([]);
    const [error, setError] = useState(null);

    const handleChange = (e) => {
        setSelectedEmployee(e.target.value);
    };

    const bindEmployee = useCallback(async () => {
        try {
            const response = await API.bindEmployeeList({
                is_active: 1,
                 limit: 0,
            });

           // console.log('response?.data?.data?.rows',response?.data?.data)
            setEmployeeList(response?.data?.data || []);
        } catch (error) {
            setError("Failed to fetch employees.");
            console.error(error);
            if (error?.response?.status === 403) {
                window.location.replace("/Login");
            }
        }
    }, []);

    useEffect(() => {
        bindEmployee();
    }, [bindEmployee]);

    return (
        <div className="row">
            <div className="col-md-12">
                <div className="form-group">
                    <label htmlFor="ddlEmployee">Employee <span style={{ color: "red" }}>*</span></label>
                    <select
                        className="form-select"
                        id="ddlEmployee"
                        value={selectedEmployee}
                        onChange={handleChange}
                    >
                        <option value="">Select</option>
                        {employeeList.length > 0 ? (
                            employeeList.map((emp) => (
                                <option key={emp.id} value={emp.id}>
                                    {emp?.first_name} {emp?.last_name} 
                                </option>
                            ))
                        ) : (
                            <option disabled>No Employees available</option>
                        )}
                    </select>
                    {error && <p style={{ color: 'red' }}>{error}</p>}
                </div>
            </div>
        </div>
    );
};

export default Employee;
